import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageBubble } from '@/pages/Schedule/components';
import { Flex, type FlexProps, Text } from '@/ui';
import { useItemCardContext } from '../context/useItemCardContext';

export const Messages = (props: FlexProps) => {
  const { instance } = useItemCardContext();
  const { t } = useTranslation('schedule', {
    keyPrefix: 'agenda_view.messages',
  });

  const messagesForInstance = useMemo(() => {
    if (!instance) {
      return [];
    }

    const messages = instance.rule
      ? instance.messages?.filter(
          (message) =>
            message.instance.toUTC().toISO() ===
            instance.startDate.toUTC().toISO()
        )
      : instance.messages;

    return messages ?? [];
  }, [instance]);

  if (!messagesForInstance.length) {
    return null;
  }

  return (
    <Flex direction="column" gap="1.5" {...props}>
      <Text
        color="customgray.mid"
        fontSize="2xs"
        fontWeight="bold"
        letterSpacing="0.1em"
        textTransform="uppercase"
      >
        {t('only_editors')}
      </Text>
      <Flex direction="column" gap="4">
        {messagesForInstance.map((message) => (
          <MessageBubble key={message.id} message={message} />
        ))}
      </Flex>
    </Flex>
  );
};
